import { render } from "./WelcomePage.vue?vue&type=template&id=57f83d69&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=57f83d69&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f83d69"]])

export default __exports__